import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import Button from "shared/components/buttons/Button";
import InputSelect from "shared/components/inputs/InputSelect";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import InputText from "shared/components/inputs/InputText";


const Dossier = ({ flowItem, flowItems, onChange, onCancel }) => {

    const { control, handleSubmit, errors, watch, register, setValue } = useForm();
    const { t } = useTranslation();

    const { osbn } = useParams();
    const { books } = useSelector(state => state.books);
    const isEdit = !!flowItem?.label;
    const book = books[osbn];
    const { measures } = book;

    const watchedMeasure = watch("measure");
    const measureKeys = Object.keys(measures);
    const measureItems = measureKeys.map(key => {
        return {
            label: measures[key].label,
            value: key
        };
    });

    useEffect(() => {
        if (!watchedMeasure || isEdit) return;

        const selectedLabel = measureItems.find(item => item.value === watchedMeasure)?.label;

        if (selectedLabel) {
            register("label", { required: true });
            setValue("label", `${t("book.chapter.status")} ${selectedLabel}`);
        }
    }, [watchedMeasure, measureItems]);

    const onSubmit = (form) => {
        onChange(form);
    };

    return (
        <div className="flow-item-form-content">
            {isEdit && <InputText
                label={t("book.activeDossier.label")}
                name="label"
                defaultValue={flowItem.label}
                control={control}
                rules={{ required: true }}
                error={errors.label}
            />}
            <InputSelect
                label={t("book.activeDossier.select")}
                defaultValue={flowItem.measure}
                name="measure"
                control={control}
                rules={{ required: true }}
                error={errors.measure}
                items={measureItems}
            />
            <InputSelect
                label={t("book.flowItem.result")}
                defaultValue={flowItem.result}
                name="result"
                control={control}
                rules={{ required: true }}
                error={errors.result}
                items={flowItems}
            />
            <div className="spacer-double" />
            <div className="container-buttons">
                <Button
                    outlined
                    spacedRight
                    label={t("button.cancel.label")}
                    onClick={onCancel}
                />
                <Button
                    label={t("button.save.label")}
                    onClick={handleSubmit(onSubmit)}
                />
            </div>
        </div>
    );
};

export default Dossier;

Dossier.propTypes = {
    flowItem: PropTypes.object.isRequired,
    flowItems: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};
